module.exports = __webpack_public_path__ + "img/text_small.47dd7961.png";